<script>
  import { createEventDispatcher } from 'svelte'
  import { cssPrefix } from '../helper-classes.js'

  export let totalCount = 100
  export let pageInfo = {}
  export let perPage = 10
  export let autoLimit = true
  export let previousLabel = 'Previous'
  export let nextLabel = 'Next'
  export let id = null

  const dispatch = createEventDispatcher()

  if (!pageInfo.startRank) pageInfo.startRank = 1

  $: pageInfo.endRank = pageInfo.startRank + perPage - 1
  $: pageInfo.pageCount = Math.ceil(totalCount / perPage)

  $: if (autoLimit) pageInfo.hasPreviousPage = pageInfo.startRank - perPage > 0
  $: if (autoLimit) pageInfo.hasNextPage = pageInfo.startRank + perPage < totalCount + 1

  let pages

  $: pageInfo.currentPage = Math.ceil(pageInfo.startRank / perPage)

  $: if (pageInfo && pageInfo.startRank) {
    pages = [1]

    if (pageInfo.currentPage === pageInfo.pageCount && pageInfo.pageCount === 4) pages.push(2)
    if (pageInfo.currentPage > 3 && pageInfo.pageCount > 4) pages.push(0)

    if (pageInfo.currentPage > 2) pages.push(pageInfo.currentPage - 1)
    if (pageInfo.currentPage > 1) pages.push(pageInfo.currentPage)
    if (pageInfo.currentPage < pageInfo.pageCount) pages.push(pageInfo.currentPage + 1)
    if (pageInfo.currentPage + 2 < pageInfo.pageCount) pages.push(pageInfo.pageCount === 4 ? pageInfo.pageCount - 1 : 0)

    if (pageInfo.currentPage + 1 < pageInfo.pageCount) pages.push(pageInfo.pageCount)
  }

  const goPage = page => {
    dispatch('go', (page - 1) * perPage + 1)
  }

  const goPreviousPage = () => {
    if (pageInfo.hasPreviousPage) dispatch('previous')
  }

  const goNextPage = () => {
    if (pageInfo.hasNextPage) dispatch('next')
  }

  export const go = rank => {
    pageInfo.startRank = rank
  }

  export const previous = () => {
    pageInfo.startRank = Math.max(pageInfo.startRank - perPage, 1)
  }

  export const next = () => {
    pageInfo.startRank = Math.min(pageInfo.startRank + perPage, totalCount)
  }
</script>

<slot />
{#if pageInfo.pageCount > 1}
  <nav class={`${cssPrefix}pagination`} {id}>
    <button
      class={`${cssPrefix}button is-previous`}
      on:click|preventDefault={goPreviousPage}
      aria-label="Previous"
      disabled={!pageInfo.hasPreviousPage}
    >
      {previousLabel}
    </button>

    <ul>
      {#each pages as page}
        <li>
          {#if page}
            <button
              on:click|preventDefault={() => goPage(page)}
              class={page === pageInfo.currentPage
                ? `${cssPrefix}button is-number selected`
                : `${cssPrefix}button is-number off`}
            >
              {page}
            </button>
          {:else}<span class={`${cssPrefix}button spacer`}>…</span>{/if}
        </li>
      {/each}
    </ul>

    <button
      class={`${cssPrefix}button is-next`}
      on:click|preventDefault={goNextPage}
      aria-label="Next"
      disabled={!pageInfo.hasNextPage}
    >
      {nextLabel}
    </button>
  </nav>
{/if}
